import { EntityType } from 'UI/constants/entityTypes';

export const LEGACY_DRAFTS_STORAGE_KEYS = Object.freeze({
  [EntityType.Candidate]: 'candidate-Drafts',
  [EntityType.Joborder]: 'joborder-Drafts'
});

export const MIGRATE_ENDPOINTS_BY_ENTITY = {
  [EntityType.Candidate]: '/inventory/candidates/drafts/legacy',
  [EntityType.Joborder]: '/inventory/job-orders/drafts/legacy'
};
